/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// import React from 'react';
import { bool } from 'prop-types';
import bottomDesktopResultPage from './svgs/bottomDesktopResultPage.svg';
import bottomMobileResultPage from './svgs/bottomMobileResultPage.svg'

const DadJokeResultPageBottomBg = ({ mobile }) => {
    return (
        <img src={mobile ? bottomMobileResultPage : bottomDesktopResultPage} alt='result page bottom bg' />
    );
};

DadJokeResultPageBottomBg.propTypes = { mobile: bool.isRequired };

export default DadJokeResultPageBottomBg;

